module.exports = __webpack_public_path__ + "static/media/togetherWeCan.c4976add.png";